// Minimal shape a store-scoped worker exposes. Both `WorkerDao` (widget-conf-dao)
// and `UserDao` (user-data-dao) satisfy this — the single `store_id` is the
// addon-OFF fallback, `stores[]` is filled only when the multi-store addon is on.
interface StoreScopedWorker {
  store_id?: number | null;
  stores?: { id: number | null | undefined }[];
}

// Returns the store ids a worker serves: the multi-store list when the addon
// fills `stores[]`, otherwise the single `store_id` (addon OFF fallback).
function servedStoreIds(worker: StoreScopedWorker | null | undefined): (number | null | undefined)[] {
  if (worker?.stores?.length) {
    return worker.stores.map(s => s.id);
  }
  return [worker?.store_id];
}

// True when the worker serves the given store. With the multi-store addon off
// this reduces to the previous `worker.store_id === storeId` behaviour.
export function workerServesStore(worker: StoreScopedWorker | null | undefined, storeId: number | null | undefined): boolean {
  if (storeId == null) {
    return false;
  }
  return servedStoreIds(worker).includes(storeId);
}
